export const NOTE_COLORS = {
  default: { light: '#ffffff', dark: '#252525', label: 'Default' },
  coral: { light: '#ffd1c8', dark: '#56312d', label: 'Red' },
  orange: { light: '#ffe0bd', dark: '#563c27', label: 'Orange' },
  butter: { light: '#fff0a8', dark: '#4c4320', label: 'Yellow' },
  mint: { light: '#ccebdc', dark: '#22483b', label: 'Green' },
  sky: { light: '#cfe7ff', dark: '#233e59', label: 'Blue' },
  indigo: { light: '#d7ddff', dark: '#30385b', label: 'Indigo' },
  lilac: { light: '#e4d7ff', dark: '#3d315b', label: 'Violet' },
} as const

export type NoteColor = keyof typeof NOTE_COLORS
export type ApprovalStatus = 'pending' | 'approved' | 'rejected'
export type NoteVisibility = 'private' | 'family'

export interface FamilyUser {
  id: string
  name: string
  email: string
  image?: string | null
  approvalStatus: ApprovalStatus
  role: 'admin' | 'user'
  cursorColor: string
}

export interface Label {
  id: string
  kind?: 'note' | 'meal'
  name: string
  color: NoteColor
  updatedAt: string
}

export interface ChecklistState {
  [lineId: string]: boolean
}

export interface Note {
  id: string
  ownerId: string
  title: string
  bodyMarkdown: string
  sortOrder: number
  color: NoteColor
  labelIds: string[]
  collaboratorIds: string[]
  visibility: NoteVisibility
  isPinned: boolean
  isChecklist: boolean
  checklistState: ChecklistState
  archivedAt: string | null
  trashedAt: string | null
  createdAt: string
  updatedAt: string
  fieldClock: Record<string, string>
}

export type NoteView = 'all' | 'shared' | 'archive' | 'trash' | `label:${string}`

export type MealWeek = 0 | 1 | 2

export interface Meal {
  id: string
  name: string
  ingredients: string[]
  labelIds: string[]
  recipeUrl: string | null
  createdAt: string
  updatedAt: string
  fieldClock: Record<string, string>
}

export interface PlannedMeal {
  id: string
  mealId: string
  week: MealWeek
  sortOrder: number
  shopped: boolean
  completedAt: string | null
  createdAt: string
  updatedAt: string
  fieldClock: Record<string, string>
}
